export const HttpHeader = {
  ContentType: 'Content-Type',
  Correlation: 'X-Correlation-Id',
};
